module.exports = __webpack_public_path__ + "static/ArpitSrivastava-resume-cadbaab1f52217b5252c6e11abcc124f.pdf";